import { Link } from "react-router-dom";
import type { FailArticle } from "@/mocks/articles";
import { categories } from "@/mocks/siteData";

const metaRow = "flex items-center justify-between gap-3 py-2.5 border-b border-background-200 last:border-b-0";

export default function ArticleSidebar({ article }: { article: FailArticle }) {
  const category = categories.find((item) => item.slug === article.categorySlug);
  const segments = Array.from({ length: 10 }, (_, index) => index < article.failIndex);

  return (
    <aside className="w-full">
      <div className="lg:sticky lg:top-32 space-y-4">
        <div className="rounded-lg bg-background-50 border border-background-200 overflow-hidden">
          <div className="px-5 py-4 bg-foreground-950">
            <h2 className="font-heading font-semibold text-sm text-background-50 flex items-center gap-2">
              <i className="ri-flashlight-line text-accent-400"></i>
              翻车指数
            </h2>
          </div>
          <div className="p-5">
            <div className="flex items-end gap-2">
              <span className="font-heading font-black text-4xl text-primary-600 leading-none">
                {article.failIndex}
              </span>
              <span className="text-sm text-foreground-500 mb-1">/ 10</span>
            </div>
            <div className="mt-4 flex items-center gap-1">
              {segments.map((on, index) => (
                <span
                  key={index}
                  className={`flex-1 h-1.5 rounded-full ${on ? "bg-primary-500" : "bg-background-300"}`}
                ></span>
              ))}
            </div>
            <p className="mt-4 text-xs leading-relaxed text-foreground-600">
              依据传播量、信息完整度与流程问题严重程度综合评定，仅供吃瓜参考。
            </p>
          </div>
        </div>

        <div className="rounded-lg bg-background-100 border border-background-200 p-5">
          <h2 className="font-heading font-semibold text-sm text-foreground-950 mb-3">事件信息</h2>
          <dl className="text-sm">
            <div className={metaRow}>
              <dt className="text-foreground-500">所属分类</dt>
              <dd>
                <Link
                  to={`/category?cat=${article.categorySlug}`}
                  className="text-primary-600 hover:text-primary-700 transition-colors"
                >
                  {article.category}
                </Link>
              </dd>
            </div>
            <div className={metaRow}>
              <dt className="text-foreground-500">整理编辑</dt>
              <dd className="text-foreground-800">{article.author}</dd>
            </div>
            <div className={metaRow}>
              <dt className="text-foreground-500">发布时间</dt>
              <dd className="text-foreground-800">{article.date}</dd>
            </div>
            <div className={metaRow}>
              <dt className="text-foreground-500">阅读量</dt>
              <dd className="text-foreground-800">{article.views}</dd>
            </div>
            <div className={metaRow}>
              <dt className="text-foreground-500">阅读时长</dt>
              <dd className="text-foreground-800">{article.readTime}</dd>
            </div>
          </dl>
        </div>

        <div className="rounded-lg bg-background-100 border border-background-200 p-5">
          <h2 className="font-heading font-semibold text-sm text-foreground-950 mb-3">相关标签</h2>
          <div className="flex flex-wrap gap-2">
            {article.tags.map((tag) => (
              <Link
                key={tag}
                to={`/category?q=${encodeURIComponent(tag)}`}
                className="px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs hover:bg-accent-200 transition-colors whitespace-nowrap"
              >
                #{tag}
              </Link>
            ))}
          </div>
          {category && (
            <p className="mt-4 text-xs leading-relaxed text-foreground-600">
              {category.name} · {category.desc}
            </p>
          )}
        </div>

        <div className="rounded-lg p-5 bg-secondary-100 border border-secondary-200">
          <h2 className="font-heading font-semibold text-sm text-secondary-950 flex items-center gap-2">
            <i className="ri-error-warning-line"></i>
            纠错与补充
          </h2>
          <p className="mt-2 text-xs leading-relaxed text-secondary-900/85">
            如果事件经过与事实有出入，欢迎附上依据反馈，我们核对后会更新并标注修订时间。
          </p>
          <Link
            to="/contact"
            className="mt-4 inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-secondary-900 text-secondary-50 text-xs whitespace-nowrap hover:bg-secondary-950 transition-colors"
          >
            反馈问题
          </Link>
        </div>
      </div>
    </aside>
  );
}